import type { SVGProps } from 'react';

const SvgIconikAgentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g filter="url(#iconik_agent_icon_svg__a)">
      <path
        fill="url(#iconik_agent_icon_svg__b)"
        d="M12 1c-3.44 0-5.162 0-6.517.567a7.3 7.3 0 0 0-3.916 3.916C1 6.838 1 8.56 1 12s0 5.162.567 6.517a7.3 7.3 0 0 0 3.916 3.916C6.838 23 8.56 23 12 23s5.162 0 6.517-.567a7.3 7.3 0 0 0 3.916-3.916C23 17.162 23 15.44 23 12s0-5.162-.567-6.517a7.3 7.3 0 0 0-3.916-3.916C17.162 1 15.44 1 12 1"
      />
      <path
        fill="url(#iconik_agent_icon_svg__c)"
        fillOpacity={0.1}
        d="M12 1c-3.44 0-5.162 0-6.517.567a7.3 7.3 0 0 0-3.916 3.916C1 6.838 1 8.56 1 12s0 5.162.567 6.517a7.3 7.3 0 0 0 3.916 3.916C6.838 23 8.56 23 12 23s5.162 0 6.517-.567a7.3 7.3 0 0 0 3.916-3.916C23 17.162 23 15.44 23 12s0-5.162-.567-6.517a7.3 7.3 0 0 0-3.916-3.916C17.162 1 15.44 1 12 1"
        style={{
          mixBlendMode: 'soft-light',
        }}
      />
    </g>
    <g filter="url(#iconik_agent_icon_svg__d)">
      <path
        fill="url(#iconik_agent_icon_svg__e)"
        d="M16.849 15.567a1.428 1.428 0 1 1-.002 2.856 1.428 1.428 0 0 1 .002-2.856m-10.177.613a.947.947 0 1 1-.001 1.894.947.947 0 0 1 0-1.894Zm4.603-4.88a1.736 1.736 0 1 1 0 3.472 1.736 1.736 0 0 1 0-3.471Zm5.066-1.19a1.933 1.933 0 1 1 0 3.867 1.933 1.933 0 0 1 0-3.867m-4.6-4.532a1.934 1.934 0 1 1 0 3.868 1.934 1.934 0 0 1 0-3.868m4.6 0a1.934 1.934 0 1 1 0 3.868 1.934 1.934 0 0 1 0-3.868m-9.189 0a1.428 1.428 0 1 1 0 2.856 1.428 1.428 0 0 1 0-2.856"
      />
    </g>
    <defs>
      <linearGradient
        id="iconik_agent_icon_svg__b"
        x1={24.956}
        x2={24.956}
        y1={3.873}
        y2={25.873}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#373737" />
        <stop offset={1} stopColor="#090909" />
      </linearGradient>
      <linearGradient
        id="iconik_agent_icon_svg__c"
        x1={24.956}
        x2={24.956}
        y1={3.873}
        y2={25.873}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.151} stopColor="#fff" />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <linearGradient
        id="iconik_agent_icon_svg__e"
        x1={14.465}
        x2={3.673}
        y1={8.969}
        y2={17.702}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#04C8DA" />
        <stop offset={0.471} stopColor="#009FFF" />
        <stop offset={1} stopColor="#4B42AD" />
      </linearGradient>
      <filter
        id="iconik_agent_icon_svg__a"
        width={22.797}
        height={22.797}
        x={0.469}
        y={0.469}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.133} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1_783" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1_783"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-0.531} dy={-0.531} />
        <feGaussianBlur stdDeviation={0.266} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend in2="shape" result="effect2_innerShadow_1_783" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.332} />
        <feGaussianBlur stdDeviation={0.066} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.13 0" />
        <feBlend
          in2="effect2_innerShadow_1_783"
          result="effect3_innerShadow_1_783"
        />
      </filter>
      <filter
        id="iconik_agent_icon_svg__d"
        width={16.361}
        height={16.655}
        x={3.82}
        y={5.578}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.906} />
        <feGaussianBlur stdDeviation={0.953} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.41 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1_783" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1_783"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgIconikAgentIcon;
